// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.reflect.is-extensible.js
// module id = ./node_modules/core-js/modules/es6.reflect.is-extensible.js
// module chunks = polyfill